/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ from: NonNullable<unknown>, to: NonNullable<unknown> }} Receipt_Change_PagesInputs */



/**
* | output |
* | --- |
* | "Page pack {from} → {to}" |
*
* @param {Receipt_Change_PagesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const receipt_change_pages = /** @type {((inputs: Receipt_Change_PagesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_Change_PagesInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Seitenpaket ${i?.from} → ${i?.to}`)
	return /** @type {LocalizedString} */ (`Page pack ${i?.from} → ${i?.to}`)
});